import { Box, List, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const SidebarContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  padding: "44px 32px 32px 32px",
  width: "280px",
  height: "100vh",
  position: "fixed",
  top: 0,
  left: 0,
  background: colors.background.secondary,
  overflowY: "auto",
  zIndex: 1000,
});

export const LogoContainer = styled(Box)({
  marginBottom: "60px",
});

export const PersonContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 16,
  cursor: "pointer",
  padding: "8px",
  borderRadius: "8px",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const NavList = styled(List)({
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: 8,
});
